export var UserRoles = {
    Godmin: "godmin",
    Lobadmin: "lobadmin",
    Opadmin: "opadmin",
};
